import styled from 'styled-components';
// import { MdHome, MdEvent, MdSupervisorAccount } from 'react-icons/md';

export const Container = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: space-around;
    height: 100%;
    padding: 15px;
`;
export const ContainerAgenda = styled.div`
    display:flex;
    flex-direction: column;
    height:100%;
    background-color: var(--cardBackgroundColor);
    border-radius: 5px;
    min-width:600px;
    width: calc(100%);
`;
export const ContainerNotas = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    height:100%;
    min-width:calc(100vw / 4);
    background-color:var(--cardBackgroundColor);
    border-radius: 5px;
    margin-left: 15px;
    margin-bottom: 15px;

    >h2{
        padding: 15px 0px;
    }
`;
export const ContainerAviso = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    height:100%;
    min-width:calc(100vw / 4);
    margin-left: 15px;
    background-color: var(--cardBackgroundColor);
    border-radius: 5px;

    >h2{
        padding: 15px 0px;
    }
`;

export const ContainerCalendar = styled.div`

`;

export const ContainerListAgendamentos = styled.div`
    display:flex;
    flex-direction: row;
`;
